import { TextField, Autocomplete } from '@mui/material';

import React from 'react';

interface IProps {
  label: string;
  variant?: 'standard' | 'filled' | 'outlined' | undefined;
  onChange: (value: string | null | number) => void;
  options?: Array<{
    name: string;
    value: string | number;
  }>;
  type?: string;
  className?: string;
}

const AdvancedAutocomplete = ({
  label,
  variant,
  onChange,
  options,
  type = 'search',
  className,
}: IProps) => (
  <div className={`advanced-input ${className || ''}`}>
    <Autocomplete
      disableClearable
      options={options ? options : [{ name: '', value: 100 }]}
      getOptionLabel={(option) => option.name}
      onChange={(element, value) => onChange(value.value)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          InputProps={{ ...params.InputProps, type }}
        />
      )}
    />
  </div>
);
export default AdvancedAutocomplete;
